<breadcrumb endText="Logs" [navigations]="breadcrumbNavs" />
<div class="m-8 gap-5">
  <h1 class="font-medium text-xl mb-2">
    System Logs
  </h1>
  <hr/>
  <div class="lg:w-[225px] w-[190px] my-5 flex input">
    <fa-icon [icon]="faMagnifyingGlass" [style]="iconStyle" />
    <input type="text" class="flex-grow w-full border-0 bg-[#F6F7F8] outline-none text-xs" placeholder="Search" [(ngModel)]="searchText" />
  </div>
  @for (file of files; track file; let i = $index) {
    <div>
      @if (file.toLowerCase().includes(searchText.toLowerCase())) {
        <button tooltip="Download" tooltipPosition="below" (click)="readFile(file)" [ngClass]="i % 2 === 0? 'mt-2 p-2 rounded-[8px] w-full text-left flex justify-between hover:bg-gray-200': 'mt-2 p-2 rounded-[8px] bg-gray-100 w-full text-left flex justify-between hover:bg-gray-200'">
          {{file}}
        </button>
      }
    </div>
  }
  @if (isLoadingList) {
    <div>
      @for (item of [0,1,2]; track item) {
        <div class="animate-pulse rounded-[8px] bg-gray-200 mt-2 h-[40px] flex"></div>
      }
    </div>
  }
</div>
